<i18n>
{
"en": {
  "GUARDIANS": "Guardians",
  "MANAGEGUARDIAN": "Manage Guardian",
  "CHOOSEFILTERBY": "Choose Filter By",
  "NAME": "Name",
  "RELATION": "Relation",
  "FATHER": "Father",
  "MOTHER": "Mother",
  "GUARDIAN": "Guardian",
  "PERSONID": "Person ID",
  "STUDENTS": "Students",
  "EDITPERSON": "Edit Person",
  "ADDNEWGUARDIAN": "Add New Guardian",
  "SEARCHGUARDIAN": "Search Guardian",
  "SEARCHBYRELATION": "Search By Relation",
  "LOADING": " Loading...",
  "MANAGEGUARDIANS": "Manage Guardians",
  "UPLOADCSVFILE": "Upload CSV File",
  "SEARCHBYSTATUS": "Search by status",
  "ACTIVE": "Active",
  "INACTIVE": "Inactive",
  "STATUS": "Status",
  "SENDMESSAGE": "Send Message",
  "ACTIVATEPERSON": "Activate Person",
  "DEACTIVATEPERSON": "Deactivate Person",
  "AREYOUSUREYOUWANTTO": "Are you sure you want to",
  "RESTORETHISSTUDENT": "restore this student?",
  "DEACTIVATETHISSTUDENT": "deactivate this student?",
  "CANCEL": "Cancel",
  "CONFIRM": "Confirm",
  "GUARDIANNAME": "Guardian Name",
  "FIRSTNAME(ARABIC)": "First Name (Arabic)",
  "FATHERNAME": "Father Name",
  "FATHERNAME(ARABIC)": "Father Name (Arabic)",
  "LASTNAME(ARABIC)": "Last Name (Arabic)",
  "NATIONALITY": "Nationality",
  "FIRSTNAME": "First Name",
  "LASTNAME": "Last Name",
  "STUDENTID": "Student ID",
  "EMAILADDRESS": "Email Address",
  "GENDER": "Gender",
  "IDENTIFICATIONNUMBER": "Identification Number",
  "IDEXPIRATIONDATE": "ID Expiration Date",
  "MOBILEPHONE": "Mobile Phone",
  "LANDLINEPHONE": "LandlinePhone",
  "GUARDIANCANNOTBEDELETED": "Guardian cannot be deleted, has assigned students!",
  "GUARDIANHASNOSTUDENTS": "Guardian has no students",
  "GUARDIANHASBEEN": "Guardian has been",
  "RESTORED": "restored!",
  "DEACTIVATED": "deactivated!",
  "GUARDIANCANNOTBEENDELETED": "Guardian cannot been deleted!",
  "PRIMARYCONTACT": "Primary Contact",
  "MOBILENO": "Mobile No",
  "SEARCHPERSONID": "Search PersonID",
  "SEARCHMOBILENO": "Search Mobile No"
},
"ar": {
  "GUARDIANS": "ولي الامر",
  "MANAGEGUARDIAN": "ادارة أولياء الامور",
  "CHOOSEFILTERBY": "اختر الفلتر المطلوب",
  "NAME": "الاسم",
  "RELATION": "الصلة",
  "FATHER": "الاب",
  "MOTHER": "الام",
  "GUARDIAN": "ولي الامر",
  "PERSONID": "الرقم الشخصي",
  "STUDENTS": "الطلاب",
  "EDITPERSON": "تحديث الشخص",
  "ADDNEWGUARDIAN": "اضافة ولي الامر جديد",
  "SEARCHGUARDIAN": "ابحث عن ولي الامر",
  "SEARCHBYRELATION": "البحث بالصلة",
  "LOADING": "جار التحميل...",
  "MANAGEGUARDIANS": "إدارة الأولياء",
  "UPLOADCSVFILE": "تحميل ملف CSV",
  "SEARCHBYSTATUS": "البحث حسب الحالة",
  "ACTIVE": "مفعل",
  "INACTIVE": "غير مفعل",
  "STATUS": "الحالة",
  "SENDMESSAGE": "إرسال رسالة",
  "ACTIVATEPERSON": "تفعيل الشخص",
  "DEACTIVATEPERSON": "إلغاء تفعيل الشخص",
  "AREYOUSUREYOUWANTTO": "هل أنت متأكد أنك تريد",
  "RESTORETHISSTUDENT": "استعادة هذا الطالب؟",
  "DEACTIVATETHISSTUDENT": "إلغاء تفعيل هذا الطالب ؟",
  "CANCEL": "إلغاء",
  "CONFIRM": " تاكيد ",
  "GUARDIANNAME": "إسم ولي الأمر",
  "FIRSTNAME(ARABIC)": "الاسم الأول (عربي) ",
  "FATHERNAME": "اسم الاب",
  "FATHERNAME(ARABIC)": "اسم الأب (عربي) ",
  "LASTNAME(ARABIC)": "الإسم العائلي(عربي) ",
  "NATIONALITY": "الجنسية",
  "FIRSTNAME": "الأسم الأول",
  "LASTNAME": "اسم العائلة",
  "STUDENTID": "هوية الطالب",
  "EMAILADDRESS": "عنوان البريد الإلكتروني",
  "GENDER": "الجنس",
  "IDENTIFICATIONNUMBER": "رقم الهوية",
  "IDEXPIRATIONDATE": "انتهاء صلاحية الهوية",
  "MOBILEPHONE": "الهاتف المحمول",
  "LANDLINEPHONE": "الهاتف الثابت",
  "GUARDIANCANNOTBEDELETED": "لا يمكن حذف ولي الأمر،له طلاب معينين!",
  "GUARDIANHASNOSTUDENTS": "ليس لولي الأمر أي طلاب",
  "GUARDIANHASBEEN": "وكان الجارديان",
  "RESTORED": "رمم!",
  "DEACTIVATED": "معطلة!",
  "GUARDIANCANNOTBEENDELETED": "الجارديان لا يمكن حذف!",
 "PRIMARYCONTACT": "Primary Contact"  
 } 
}
</i18n>
<template>
  <div>
    <el-card  class="card-border" ref="card" :body-style="{ padding: 0 }">
      <div slot="header" class="clearfix">
        <span style="line-height: 36px;" class="title">{{$t('MANAGEGUARDIANS')}}</span>
        <el-dropdown trigger="click" type="dark">
          <el-button-group>
            <el-button @click="$router.push({path:'/school/guardian/create'})" :disabled="!isAllowed('save')">
               <i class="el-icon-plus"></i> {{$t('ADDNEWGUARDIAN')}}
            </el-button>
            <el-button ref="trigger" class="el-dropdown__caret-button">
              <i class="el-dropdown__icon el-icon-caret-bottom"></i>
            </el-button>
          </el-button-group>
          <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :disabled="!isAllowed('import')">
          <el-upload
            ref="upload"
            accept=".csv"
            class="upload-demo"
            :action="URL + 'media/upload'"
            :data="import_data"
            :headers="{'Accept-Language': currentLang(), 'X-API-KEY': API_KEY}"
            :with-credentials="true"
            :on-success="uploadedFile">
            <i class="fa fa-upload"></i> {{$t('UPLOADCSVFILE')}}
          </el-upload>   
          </el-dropdown-item>
        </el-dropdown-menu>
        </el-dropdown>
      </div>

      <div class="filters" ref="filter">
        <el-row :gutter="20">
          <el-col :span="4">
            <el-select  v-model="filter" @change="changedFilter" :placeholder="$t('CHOOSEFILTERBY')">
              <el-option
                v-if="item.value!=active_filter"
                :key="index" v-for="(item, index) in options"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>

          <el-col :span="4" v-if="active_filter=='name'">
            <el-input v-model="FullName"  :placeholder="$t('SEARCHGUARDIAN')" @change="getGuardians(true)" :icon="FullName=='' ? '' : 'circle-close'" :on-icon-click="clearInput">
            </el-input>
           </el-col>
          <el-col :span="4" v-if="active_filter=='id'">
            <el-input v-model="PersonID"  :placeholder="$t('SEARCHPERSONID')" @change="getGuardians(true)" :icon="PersonID=='' ? '' : 'circle-close'" :on-icon-click="clearInput">
            </el-input>
           </el-col>
          <el-col :span="4" v-if="active_filter=='mobile'">
            <el-input v-model="MobileNo"  :placeholder="$t('SEARCHMOBILENO')" @change="getGuardians(true)" :icon="MobileNo=='' ? '' : 'circle-close'" :on-icon-click="clearInput">
            </el-input>
           </el-col>
         <el-col :span="4"  v-if="active_filter=='relation'">
             <el-select :disabled="loading"  v-model="Relation" :placeholder="$t('SEARCHBYRELATION')" @change="getGuardians(true)" :filterable="true" clearable>
               <el-option :label="$t('FATHER')" value="Father"></el-option>
               <el-option :label="$t('MOTHER')" value="Mother"></el-option>
               <el-option :label="$t('GUARDIAN')" value="Guardian"></el-option>
            </el-select>  
           </el-col>
          <el-col :span="4"  v-if="active_filter=='status'">
             <el-select :disabled="loading"  v-model="Status" :placeholder="$t('SEARCHBYSTATUS')" @change="getGuardians(true)" clearable>
              <el-option :label="$t('ACTIVE')" value="1">
                <el-tag
                 type="success"
                close-transition>{{$t('ACTIVE')}}</el-tag>
              </el-option>
               <el-option :label="$t('INACTIVE')" value="2">
                <el-tag
                 type="danger"
                close-transition>{{$t('INACTIVE')}}</el-tag>
              </el-option>
            </el-select>       
           </el-col>             
        </el-row>
      </div>
      <el-table
      v-loading="new_page || loading"    
      :element-loading-text="$t('LOADING')"
        :data="listGuardians"
        highlight-current-row
        :height="tableHeight"
        stripe
        style="width: 100%"
        >

       <el-table-column type="expand">
          <template slot-scope="props">
          <el-row>
            <div class="expanded-student el-col el-col-4" :span="4" :key="index" v-for="(student, index) in props.row.students" @click="$router.push('/school/student/' + student.StudentID)">
                <img :src="getAsset(student.ImagePath, 'student')" alt="" class="img-circle" style="cursor: pointer;"><br/>
                {{_FullName({NameEN: student.FullName_EN, NameAR: student.FullName_AR})}}
            </div>
           </el-row>
          </template>
       </el-table-column>

        <el-table-column
          prop="ExternalPersonID"
          :label="$t('PERSONID')"
          min-width="150"
          class="center"
          align="left"
          sortable>
        </el-table-column>
        <el-table-column
          :label="$t('NAME')"
          min-width="200"
          align="left"
        sortable>
          <template slot-scope="scope">
            <img :src="getAsset(scope.row.ImagePath)" alt="" class="img-circle">
            {{_FullName({NameEN: scope.row.FullName_EN, NameAR: scope.row.FullName_AR})}}


          </template>
        </el-table-column>
        <el-table-column
          prop="MobilePhone"
          :label="$t('MOBILENO')"
          min-width="100"
          align="center"
          >        
        </el-table-column>
        <el-table-column
          :label="$t('RELATION')"
          min-width="100"
          align="center"
          sortable>
          <template slot-scope="scope">
            {{$t(scope.row.Relation)}}
          </template>          
        </el-table-column>
        <el-table-column
          prop="Status"
          :label="$t('STATUS')"
          min-width="100"
          align="center"
          sortable>

          <template slot-scope="scope">
              <el-tag
                :type="parseInt(scope.row.Status) !== 1  ? 'success' : 'danger'"
                close-transition>{{parseInt(scope.row.Status) !== 1 ? $t('ACTIVE') : $t('INACTIVE')}}</el-tag>
          </template>

        </el-table-column>

        <el-table-column
          label=""
          min-width="200"
          align="center"
          class="actions">

          <template slot-scope="scope">
              <el-tooltip v-if="isAllowed('send', 'report/message')" :content="$t('SENDMESSAGE')" placement="top">
                <el-button type="text" @click="showMessageModal(scope.row)"><i class="fa fa-comment"></i></el-button>
              </el-tooltip >
              <el-tooltip v-if="isAllowed('save')" :content="$t('EDITPERSON')" placement="top">
                <el-button type="text" @click="$router.push({path:'/school/guardian/'+scope.row.PersonID})"><i class="fa fa-pencil"></i></el-button>
              </el-tooltip>
              <el-tooltip v-if="isAllowed('delete')" :content="listGuardians[scope.$index].Status==0 ? $t('DEACTIVATEPERSON') : $t('ACTIVATEPERSON')" placement="top">
                <el-popover
                  trigger="manual"
                  placement="left"
                  width="160"
                  @show="guardian=listGuardians[scope.$index]"
                  v-model="listGuardians[scope.$index].Deleted">
                    <p> {{$t('AREYOUSUREYOUWANTTO') + ' '}} {{listGuardians[scope.$index].Status==0 ? $t('DEACTIVATETHISSTUDENT') : $t('RESTORETHISSTUDENT')}}</p>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="text" @click="listGuardians[scope.$index].Deleted = false">{{$t('CANCEL')}}</el-button>
                    <el-button type="primary" size="mini" @click="toggleStatus(scope.$index)">{{$t('CONFIRM')}}</el-button>
                  </div>
                  <el-button style="margin-left:10px" type="text" @click="checkRoute(scope.$index)" slot="reference"><i class="fa" :class="[scope.row.Status!= 0 ? 'fa-undo' : 'fa-times']"></i> </el-button>
                </el-popover>
              </el-tooltip>                            
          </template>
        </el-table-column>
      </el-table>
      <div style="padding:10px" ref="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 30, 50, 70, 100]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next"
          :total="totalGuardians">
        </el-pagination>
      </div>
      <el-message-dialog :visible.sync="messageBox" :showRemove="false" :studentList="students" :parent="guardian"></el-message-dialog>
      <el-import-dialog @reCall="getGuardians" :visible.sync="dialogImport" :fields="fields" :title="$t('GUARDIANS')" uri="guardian/import" :CSVReader="CSVReader" :CSVFile="CSVFile"></el-import-dialog>  
    </el-card>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import _ from 'lodash'
  import qs from 'qs'
  import MessageDialog from '@/components/dialogs/Message'
  import ImportDialog from '@/components/dialogs/Import'
  export default {
    components: {'el-message-dialog': MessageDialog, 'el-import-dialog': ImportDialog},
    data () {
      return {
        guardians: {},
        students: [],
        guardian: {Deleted: false},
        filter: null,
        active_filter: 'name',
        loading: true,
        indexCheck: null,
        prevIndex: null,
        FullName: '',
        MobileNo: '',
        PersonID: '',
        Status: '',
        Relation: '',
        currentRow: null,
        new_page: false,
        tableHeight: 0,
        totalGuardians: 0,
        totalFilter: 0,
        currentPage: 1,
        visitedPage: [1],
        limit: 20,
        sending: false,
        CSVReader: {},
        CSVFile: '',
        dialogImport: false,
        messageBox: false,
        autoSource: null,
        import_data: {}
      }
    },
    computed: {
      listGuardians () {
        if (this.guardians[this.currentPage - 1] === undefined) return
        let guardians = this.guardians[this.currentPage - 1]
        return guardians
      },
      options () {
        let options = [{
          value: 'name',
          label: this.$t('GUARDIANNAME')
        }, {
          value: 'relation',
          label: this.$t('RELATION')
        }, {
          value: 'mobile',
          label: this.$t('MOBILENO')
        }, {
          value: 'id',
          label: this.$t('PERSONID')
        }, {
          value: 'status',
          label: this.$t('STATUS')
        }]
        return options
      },
      fields () {
        let fields = [
          {label: this.$t('STUDENTID'), field: 'ExternalStudentID', required: true, format: null},
          {label: this.$t('FIRSTNAME'), field: 'FirstName_EN', required: true, format: null},
          {label: this.$t('FATHERNAME'), field: 'MiddleName', required: true, format: null},
          {label: this.$t('LASTNAME'), field: 'LastName_EN', required: true, format: null},
          {label: this.$t('FIRSTNAME(ARABIC)'), field: 'FirstName_AR', required: false, format: null},
          {label: this.$t('FATHERNAME(ARABIC)'), field: 'MiddleName_AR', required: false, format: null},
          {label: this.$t('LASTNAME(ARABIC)'), field: 'LastName_AR', required: false, format: null},
          {label: this.$t('NATIONALITY'), field: 'Nationality', required: true, format: null},
          {label: this.$t('IDENTIFICATIONNUMBER'), field: 'ExternalPersonID', required: true, format: null},
          {label: this.$t('IDEXPIRATIONDATE'), field: 'IDExpiration', required: true, format: 'date'},
          {label: this.$t('MOBILEPHONE'), field: 'MobilePhone', required: true, format: null},
          {label: this.$t('LANDLINEPHONE'), field: 'LandlinePhone', required: false, format: null},
          {label: this.$t('EMAILADDRESS'), field: 'EMail', required: true, format: null},
          {label: this.$t('RELATION'), field: 'Relation', required: true, format: null},
          {label: this.$t('PRIMARYCONTACT'), field: 'IsMain', required: true, format: null}
        ]
        return fields
      }
    },
    mounted () {
      this.switchLanguage()
      this.import_data = {folder: this.$route.path.split('/')[2], type: 'import'}
      this.tableHeight = window.innerHeight - (this.$refs.card.$el.children[0].offsetHeight + this.$refs.filter.offsetHeight + this.$refs.pagination.offsetHeight + 53)
      this.getGuardians()
    },
    methods: {
      removeFilter (filter) {
        this.filter = ''
        this.guardians = {}
        this.getGuardians()
      },
      currentLang () {
        return localStorage.getItem('lang')
      },
      clearInput () {
        this.FullName = this.Status = this.Relation = this.MobileNo = this.PersonID = ''
        this.guardians = {}
        this.getGuardians()
      },
      filterBy (arr, search, delimiter) {
        if (!search) return arr
        let res = []
        arr.filter(function (el) {
          if (typeof delimiter === 'object') {
            let regx = new RegExp('^' + search, 'i')
            if (regx.test(el[delimiter[0]]) || regx.test(el[delimiter[1]])) res.push(el)
          } else {
            search = '^' + search
            if (new RegExp(search, 'i').test(el[delimiter])) res.push(el)
          }
        })
        return res
      },
      handleCurrentChange (val) {
        this.currentPage = val
        if (this.visitedPage.indexOf(val) >= 0) return
        this.visitedPage.push(val)
        this.new_page = true
        this.getGuardians()
      },
      handleSizeChange (val) {
        this.limit = val
        this.guardians = {}
        this.currentPage = 1
        this.visitedPage = [1]
        this.loading = true
        this.getGuardians()
      },
      getGuardians (filter = false) {
        let self = this
        if (filter) {
          self.currentPage = 1
          self.visitedPage = [1]
          self.new_page = true
          self.guardians = {}
        }
        if (self.guardians[self.currentPage - 1] !== undefined) return
        if (this.autoSource) this.autoSource.cancel()
        this.autoSource = axios.CancelToken.source()
        this.$http.get('/guardian?' + qs.stringify(self.bindCurrentFilters()) + '&limit=' + self.limit + '&offset=' + self.limit * (self.currentPage - 1), {cancelToken: this.autoSource.token})
          .then(function (response) {
            self.autoSource = null
            for (let guardian in response.data.guardians) {
              response.data.guardians[guardian].Deleted = false
            }
            Vue.set(self.guardians, self.currentPage - 1, response.data.guardians)
            self.new_page = self.loading = false
            self.totalGuardians = response.data.total
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      bindCurrentFilters () {
        let data = {filters: []}
        switch (this.active_filter) {
          case 'name': data.filters['FullName'] = this.FullName
            break
          case 'relation': data.filters['Relation'] = this.Relation
            break
          case 'id': data.filters['PersonID'] = this.PersonID
            break
          case 'mobile': data.filters['MobileNo'] = this.MobileNo
            break
          case 'status': data.filters['Status'] = this.Status
            break
        }
        return data
      },
      toggleStatus (index) {
        let self = this
        let postData = {PersonID: self.listGuardians[index].PersonID, Status: self.listGuardians[index].Status}
        this.$http.post('/guardian/delete', postData)
          .then(function (response) {
            self.guardians = {}
            self.visitedPage = [self.currentPage]
            self.getGuardians()
            self.$message({
              message: response.data.error ? self.$t('GUARDIANCANNOTBEENDELETED') : self.$t('GUARDIANHASBEEN') + ' ' + (response.data.status === '1' ? self.$t('RESTORED') : self.$t('DEACTIVATED')),
              type: response.data.error ? 'error' : 'success',
              showClose: true
            })
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      checkRoute (index) {
        let self = this
        let guardian = self.listGuardians[index]
        guardian.Deleted = false
        if (self.indexCheck === guardian.PersonID) return
        self.prevIndex = index
        if (guardian.students.length !== 0) {
          guardian.Deleted = false
          self.indexCheck = guardian.PersonID
          return self.$message({
            message: self.$t('GUARDIANCANNOTBEDELETED'),
            type: 'warning',
            showClose: true,
            onClose: function () {
              self.indexCheck = null
            }
          })
        } else guardian.Deleted = true
      },
      deleteGuadian () {
      },
      changedFilter (val) {
        if (val === null) return
        this.active_filter = val
        this.filter = null
        let load = false
        if (this.FullName !== '' || this.Relation !== '' || this.Status !== '' || this.MobileNo !== '' || this.PersonID !== '') load = true
        if (load) {
          this.FullName = this.Relation = this.Status = this.MobileNo = this.PersonID = ''
          this.getGuardians(true)
        }
      },
      showMessageModal (parent) {
        if (parent.students.length === 0) {
          return self.$message({
            message: self.$t('GUARDIANHASNOSTUDENTS'),
            type: 'warning',
            showClose: true
          })
        }
        this.students = parent.students
        this.guardian = _.pick(parent, ['FullName_AR', 'FullName_EN', 'ImagePath', 'IsMain', 'PersonID', 'Relation', 'deleted'])
        this.messageBox = true
      },
      uploadedFile (response, file, fileList) {
        if (response.error) {
          return this.$message({
            message: response.error,
            type: 'error',
            showClose: true
          })
        }
        this.CSVReader = response.fields
        this.CSVFile = response.file_name
        this.dialogImport = true
      }
    }
  }
</script>

<style>
  .expanded-student:hover{background-color: rgb(242, 242, 242) !important;cursor: pointer;}
</style>



// WEBPACK FOOTER //
// Guardian.vue?18df7b85